module.exports = __webpack_public_path__ + "static/media/partial-select_light.bc06634f.svg";